module.exports = __webpack_public_path__ + "assets/icons/accepted-emoji.gif";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/accepted-emoji.gif
// module id = ./src/styles/icons/emojies/accepted-emoji.gif
// module chunks = 0